// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__224aV","title":"FrontImage_title__C_OnU"};